import wNumb from 'wnumb';

export default class CurrencyFormatter {
    constructor(overrides) {
        const currencySymbol = window.HONDA?.currency?.symbol;
        if (currencySymbol) {
            window.HONDA.currency.ISO = window.HONDA.DataLayerHelper?.getCurrencyISO(currencySymbol);
        }

        const options = { ...window.HONDA.currency, ...overrides };
        return wNumb({
            mark: options.decimalSymbol,
            thousand: options.groupDigits ? options.digitGroupSymbol : '',
            decimals: options.roundToDecimalPlace,
            negativeBefore: '-',
            prefix: options.positiveFormat.indexOf('s') < options.positiveFormat.indexOf('n') ? options.symbol : '',
            suffix: options.positiveFormat.indexOf('s') > options.positiveFormat.indexOf('n') ? options.symbol : '',
        });
    }
}
